import script from "./ForMemorialPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ForMemorialPage.vue?vue&type=script&setup=true&lang=js"

import "./ForMemorialPage.vue?vue&type=style&index=0&id=10a587ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a587ee"]])

export default __exports__